jQuery(document).ready(function ($) {
    var $window = $(window);
    var swiper = new Swiper(".events-calendar__container", {
        direction: "vertical",
        autoHeight: true,
        mousewheel: true,
        shortSwipes: false,
        navigation: {
            nextEl: ".events-calendar__button--next",
            prevEl: ".events-calendar__button--prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 4,
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });

    var upcoming = $(".swiper-slide.upcoming");

    var upcomingIndex = upcoming.index();
    if (upcoming.length) {
        upcoming.find(".events-calendar__event").first().addClass("active");
        swiper.slideTo(upcomingIndex);
        var upcomingCard = upcoming.find(".events-calendar__card").first();
        var upcomingCardClone = upcomingCard.clone();
        $("#events-calendar__cards").append(upcomingCardClone);
    } else {
        swiper.slideTo(swiper.slides.length);
        $(".swiper-slide:last-child .events-calendar__event").addClass(
            "active"
        );
        var lastCard = $(".swiper-slide:last-child .events-calendar__card");
        var lastCardClone = lastCard.clone();
        $("#events-calendar__cards").append(lastCardClone);
    }
    swiper.on("transitionEnd", function () {
        $(".events-calendar__container").css("opacity", 1);
    });

    $window.on("resize", function () {
        if ($window.width() > 768) {
            $(".events-calendar__event").on("click", function () {
                $("#events-calendar__cards").html("");
                $(".events-calendar__event").removeClass("active");
                $(this).addClass("active");
                var container = "#events-calendar__cards";
                var card = $(this).next(".events-calendar__card");
                var clone = card.clone();
                $(container).append(clone);
            });
        }
        if ($window.width() < 768) {
            swiper.mousewheel.disable();
            $(".events-calendar__event").removeClass("active");
            $(".events-calendar__slide").removeClass("active");
            $(".events-calendar__event").on("click", function () {
                var card = $(this).next(".events-calendar__card");
                swiper.params.slidesPerView = 1;
                swiper.params.spaceBetween = 100;
                swiper.update();
                if (card.css("display") == "block") {
                    card.css("display", "none");
                    swiper.params.slidesPerView = 4;
                    swiper.update();
                } else {
                    card.css("display", "block");
                }
                var clickedIndex = $(this).parent().index();
                swiper.slideTo(clickedIndex - 1);
            });

            $(
                ".events-calendar__button--prev, .events-calendar__button--next"
            ).on("click", function () {
                var openCard = $(".events-calendar__card:visible");
                if (openCard.length) {
                    $(".events-calendar__card").css("display", "none");
                    var clickedIndex = swiper.clickedIndex;
                    swiper.params.slidesPerView = 4;
                    swiper.params.spaceBetween = 0;
                    swiper.update();
                    if ($(this).hasClass("events-calendar__button--prev")) {
                        swiper.slideTo(clickedIndex - 1);
                    }
                    if ($(this).hasClass("events-calendar__button--next")) {
                        swiper.slideTo(clickedIndex + 1);
                    }
                }
            });
        }
    });
    $window.trigger("resize");
});
